module.exports = __webpack_public_path__ + "img/src/modules/web-agent/assets/img/maven-thumb.png?7d3937015b09532faff99ecc07214a3b";